import { render, staticRenderFns } from "./EmployeesCreate.vue?vue&type=template&id=5ed0ce3a"
import script from "./EmployeesCreate.vue?vue&type=script&lang=js"
export * from "./EmployeesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports